import { useMutation } from '@tanstack/react-query'

import { resyncResource } from '@/features/resource/endpoints/resources'

export function useResyncResourceMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (resourceId: string) => resyncResource(resourceId),
  })

  return {
    resyncResource: mutateAsync,
    ...mutationResult,
  }
}
